import React, { useState, useEffect, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query'

export default function Question(props){
    const [checked, setChecked] = useState(props.isChecked);
    function handleCheckboxChange(value) {
        if(value){
            props.add(props.question);
        }else{
            props.remove(props.question);
        }
        setChecked(value);

    }

    useEffect(() => {
        handleCheckboxChange(props.isChecked);
    }, [props.isChecked])

    return(
        <>
            <label key={props.index} className="flex flex__row">

                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => handleCheckboxChange(e.target.checked)}
                    className=''
                    style={{minWidth: '22px'}}
                />
                <span className='mleft--10' >{props.question.question}</span>
            </label>
        </>
    )
}